export default __webpack_public_path__ + "static/media/qufus_logo_nature.ff9aa3c6.png";